import { useState, useEffect } from 'react';

interface UseFadeInProps {
  childrenCount: number;
  visible?: boolean;
  delay?: number;
  transitionDuration?: number;
  onComplete?: () => void;
}

export const useFadeIn = ({
  childrenCount,
  visible = true,
  delay = 50,
  transitionDuration = 500,
  onComplete,
}: UseFadeInProps) => {
  const [maxIsVisible, setMaxIsVisible] = useState(0);

  useEffect(() => {
    const count = visible ? childrenCount : 0;

    if (count === maxIsVisible) {
      const timeout = setTimeout(() => {
        onComplete && onComplete();
      }, transitionDuration);
      return () => clearTimeout(timeout);
    }

    const increment = count > maxIsVisible ? 1 : -1;
    const timeout = setTimeout(() => {
      setMaxIsVisible(maxIsVisible + increment);
    }, delay);
    return () => clearTimeout(timeout);
  }, [childrenCount, delay, maxIsVisible, visible, transitionDuration, onComplete]);

  return maxIsVisible;
};
